import React, { useState } from 'react';
import QueryInput from '../../components/QueryInput';
import { pathLabel } from './pathEntity';

interface GraphSearchBarProps {
  onSeed: (name: string, label: string) => void;
  autoFocus?: boolean;
}

/** Seed the graph from any entity: actor, family, IOC, CVE or technique. */
export function GraphSearchBar({ onSeed, autoFocus }: GraphSearchBarProps) {
  const [query, setQuery] = useState('');
  return (
    <div className="graph-search-bar">
      <QueryInput
        value={query}
        onChange={setQuery}
        autoFocus={autoFocus}
        ariaLabel="Search the graph"
        placeholder="Start from an entity… e.g. APT28, win.emotet, CVE-2021-44228, domain:evil"
        excludeCategories={['country']}
        onPickEntity={(r) => {
          setQuery(r.value);
          onSeed(r.value, pathLabel(r));
        }}
        // No match picked: try the typed text as a family (old behaviour).
        onSubmit={(q) => { if (q.trim()) onSeed(q.trim(), 'MalwareFamily'); }}
      />
    </div>
  );
}
